
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'ArrowRightLongLight' })
export default class ArrowRightLongLight extends Vue {}
